import { type CSSProperties } from 'react';

import { COLOR_RED, COLOR_RED_DARK, FONT_INTER, PAGE_BODY_PADDING } from '../shared/blueprint-view-styles';

export const COVER_BODY_STYLE: CSSProperties = {
	flex: 1,
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	padding: PAGE_BODY_PADDING,
	gap: '24px',
	fontFamily: FONT_INTER,
	lineHeight: '1.4'
};

export const COVER_DISCLAIMER_STYLE: CSSProperties = {
	color: COLOR_RED,
	fontWeight: 700,
	textAlign: 'center'
};

// Fixed to the template filler size (COVER_IMAGE_PLACEHOLDER_STYLE) so the live render never grows the body.
export const COVER_IMAGE_WRAPPER_STYLE: CSSProperties = {
	width: '486px',
	height: '220px',
	flexShrink: 0,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center'
};

// Max-constrained (not object-fit) so the img box keeps the intrinsic aspect; html2canvas 1.4.1 ignores object-fit and would stretch.
export const COVER_IMAGE_STYLE: CSSProperties = {
	maxWidth: '100%',
	maxHeight: '100%'
};

export const COVER_IMAGE_PLACEHOLDER_STYLE: CSSProperties = {
	width: '486px',
	height: '220px',
	backgroundColor: '#f0f0f0',
	border: '1px dashed #ccc',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	color: '#999',
	fontSize: '10px'
};

export const COVER_COYOTE_BOX_STYLE: CSSProperties = {
	backgroundColor: COLOR_RED_DARK,
	borderRadius: '7px',
	padding: '14px',
	width: '80%',
	fontWeight: 700,
	color: '#FFF',
	textAlign: 'center',
	lineHeight: '1.4'
};

export const COVER_COYOTE_WARNING1_STYLE: CSSProperties = {
	marginBottom: '7px'
};
